module.exports = __webpack_public_path__ + "img/list_title.2221705e.png";